import {useTheme} from "@emotion/react";

import {PictogramType} from "../types/PictogramType";

export const useIconOptionsFromVariant = (variant: PictogramType) => {
    const theme = useTheme();

    switch (variant) {
        case PictogramType.LABELED_ICON:
            return {
                size: "20",
                wrapperSize: "20",
                wrapperColor: theme.colors.primary
            };
        case PictogramType.BOX:
            return {
                size: "10",
                wrapperSize: "10",
                wrapperColor: "transpaarent"
            };
        default:
            return {};
    }
};
import {useTheme} from "@emotion/react";

import {PictogramType} from "../types/PictogramType";

export const useIconOptionsFromVariant = (variant: PictogramType) => {
    const theme = useTheme();

    switch (variant) {
        case PictogramType.LABELED_ICON:
            return {
                size: "20",
                wrapperSize: "20",
                wrapperColor: theme.colors.primary
            };
        case PictogramType.BOX:
            return {
                size: "10",
                wrapperSize: "10",
                wrapperColor: "transpaarent"
            };
        default:
            return {};
    }
};
